<template>
    <div class="order-item md-layout-item">
        <div :class="{ 'delivered': orderItem.selected && editMode && isAdmin, 'not-delivered': !orderItem.selected && editMode && isAdmin, 'disabled': !orderEditable(orderItem.order_item_status_id)}">
            <div class="md-layout">
                <div class="product-name">
                    <!-- AVATAR/IMAGE -->
                    <md-avatar class="md-large">
                        <img :src="orderItem.picture_b64"
                            :alt="orderItem.picture_name">
                    </md-avatar>
                    <!-- PRODUCT NAME -->
                    <span><b>{{ orderItem.product_name }}</b><br><template v-if="orderItem.scientific_name">({{ orderItem.scientific_name }})</template></span>
                </div>
                <!-- DELETE BTN -->
                <md-button v-if="orderEditable(orderItem.order_item_status_id)"
                    class="delete-btn md-icon-button md-list-action"
                    :disabled="!orderEditable(orderItem.order_item_status_id)"
                    @click="removeFromCart(index, orderItem)">
                    <md-icon>delete</md-icon>
                </md-button>
            </div>
            <!-- QUANTITY -->
            <md-field :class="messageClass">
                <label>
                    {{ $tc('orders.quantity', 1) }}
                </label>
                <md-input v-model="orderItem.quantity"
                    type="number"
                    min="1"
                    :disabled="!orderEditable(orderItem.order_item_status_id)"
                    @change="updateCart(index, orderItem)">
                </md-input>
                <span class="md-error">{{ $t('validations.minimum') }}</span>
            </md-field>
            <!-- UNITS -->
            <md-field>
                <label>
                    {{ $tc('orders.unit', 1) }}
                </label>
                <md-select v-model="orderItem.units"
                    name="description"
                    id="unit_id"
                    md-dense
                    :disabled="units.length < 1 || !orderEditable(orderItem.order_item_status_id)"
                    @input="updateCart(index, orderItem)">
                    <md-option v-for="unit in units"
                        :key="unit.unit_id"
                        :value="unit.description">
                        {{ unit.description }}
                    </md-option>
                </md-select>
            </md-field>
            <!-- CALIBERS -->
            <md-field>
                <label>
                    {{ $tc('orders.caliber', 1) }}
                </label>
                <md-select v-model="orderItem.caliber"
                    name="caliber"
                    id="caliber_id_id"
                    md-dense
                    :disabled="calibers.length < 1 || isLoadingCalibers || !orderEditable(orderItem.order_item_status_id)"
                    @input="updateCart(index, orderItem)">
                    <md-option v-for="caliber in calibers"
                        :key="caliber.id"
                        :value="caliber.description">
                        {{ caliber.description }}
                    </md-option>
                </md-select>
            </md-field>
            <!-- STATUS -->
            <md-field>
                <label>
                    {{ $t('orders.fish-status') }}
                </label>
                <md-select v-model="orderItem.product_status"
                    name="description"
                    id="product_status_id"
                    md-dense
                    :disabled="productStatus.length < 1 || !orderEditable(orderItem.order_item_status_id)"
                    @input="updateCart(index, orderItem)">
                    <md-option v-for="status in productStatus"
                        :key="status.id"
                        :value="status.description">
                        {{ status.description }}
                    </md-option>
                </md-select>
            </md-field>
            <!-- PREPARED -->
            <md-switch v-model="orderItem.prepared"
                class="switch-btn md-primary label-switch"
                :disabled="!orderEditable(orderItem.order_item_status_id)"
                @change="value => updatePreparedAndCart(value, index, orderItem)"
                :value="true">
                {{ $t('orders.prepared') }}
            </md-switch>
            <!--OBS-->
            <md-field md-clearable>
                <label>{{ $tc('products.observation', 2) }}</label>
                <md-textarea v-model="orderItem.notes"
                    @input="updateCart(index, orderItem)"
                    md-counter="255"
                    maxlength="255"></md-textarea>
            </md-field>
            <!-- DELIVERED -->
            <div v-if="isAdmin && editMode"
                class="delivered-checkbox">
                <v-checkbox v-model="orderItem.selected"
                    class="checkbox-btn md-layout-item"
                    :label="$tc('products.delivered')"
                    :disabled="!orderEditable(orderItem.order_item_status_id)"
                    @change="updateCart(index, orderItem)"
                    primary
                    hide-details>
                </v-checkbox>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import productsService from '@/components/products/services/'
import OrderStatus from '@/utils/orderStatus'

export default {
    name: 'CheckoutListItem',

    props: {
        item: {
            type: Object,
            default: null
        },

        units: {
            type: Array,
            default: null
        },

        productStatus: {
            type: Array,
            default: null
        },

        index: {
            type: Number,
            default: null
        },

        editMode: {
            type: Boolean,
            default: false
        }
    },

    data () {
        return {
            orderItem: {},

            calibers: [],

            isLoadingCalibers: false,

            showNotes: true,

            isCheckout: false
        }
    },

    methods: {
        removeFromCart (index, item) {
            this.$emit('remove-from-cart', { index, item })
        },

        updateCart (index, item) {
            this.$emit('update-cart', { index: index, item: item })
        },

        updatePreparedAndCart (value, index, item) {
            let self = this
            if (value === null) {
                self.orderItem.prepared = false
            } else {
                self.orderItem.prepared = true
            }
            this.$emit('update-cart', { index: index, item: item })
        },

        async fetchProductCalibers () {
            let self = this

            let params = {
                filter: {
                    product_id: self.orderItem.product_id
                }
            }
            this.isLoadingCalibers = true

            let response = await productsService.getProductCalibers(params)
            self.calibers = _.cloneDeep(response.data)

            this.isLoadingCalibers = false
        },

        orderVisible (id) {
            return OrderStatus.orderVisible(id)
        },

        orderEditable (id) {
            return OrderStatus.orderEditable(id)
        }
    },

    computed: {
        isAdmin () {
            return this.$store.getters.user.role === 'ADMIN'
        },

        messageClass () {
            return {
                'md-invalid': !this.orderItem.quantity
            }
        }
    },

    created () {
        this.orderItem = _.cloneDeep(this.item)
        this.fetchProductCalibers()
    }
}
</script>
